// src/components/shared/MotusIcon.js
//
// Centralized SVG icon library for the motus app.
// Replaces all emoji icons with clean, consistent stroke-based SVGs.
// Uses Feather-style paths (24x24 viewBox, stroke-based, rounded caps).

import React from 'react';

const PATHS = {
  // Navigation & UI
  user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2 M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
  settings: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z',
  bell: 'M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9 M13.73 21a2 2 0 0 1-3.46 0',
  lock: 'M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2Z M7 11V7a5 5 0 0 1 10 0v4',
  logout: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4 M16 17l5-5-5-5 M21 12H9',
  warning: 'M12 9v2 M12 15h.01 M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z',
  layers: 'M12 2L2 7l10 5 10-5-10-5Z M2 17l10 5 10-5 M2 12l10 5 10-5',
  info: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z M12 16v-4 M12 8h.01',
  share: 'M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-6 M12 3v13 M8 7l4-4 4 4',

  // Media & content
  video: 'M23 7l-7 5 7 5V7Z M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z',
  film: 'M19.82 2H4.18A2.18 2.18 0 0 0 2 4.18v15.64A2.18 2.18 0 0 0 4.18 22h15.64A2.18 2.18 0 0 0 22 19.82V4.18A2.18 2.18 0 0 0 19.82 2Z M7 2v20 M17 2v20 M2 12h20 M2 7h5 M2 17h5 M17 17h5 M17 7h5',
  camera: 'M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2Z M12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
  folder: 'M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2Z',
  upload: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4 M17 8l-5-5-5 5 M12 3v12',
  mic: 'M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3Z M19 10v2a7 7 0 0 1-14 0v-2 M12 19v4 M8 23h8',
  speaker: 'M11 5L6 9H2v6h4l5 4V5Z M19.07 4.93a10 10 0 0 1 0 14.14 M15.54 8.46a5 5 0 0 1 0 7.07',

  // Status & feedback
  target: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z M21 21l-4.35-4.35',
  check: 'M20 6L9 17l-5-5',
  trophy: 'M6 9H3V4h3 M18 9h3V4h-3 M6 4h12v6a6 6 0 0 1-12 0V4Z M12 16v4 M8 20h8',
  star: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2Z',
  flame: 'M12 22c4-3 8-7 8-12a8 8 0 0 0-16 0c0 5 4 9 8 12Z M12 22c-1.5-1.5-3-3.5-3-6a3 3 0 0 1 6 0c0 2.5-1.5 4.5-3 6Z',
  zap: 'M13 2L3 14h9l-1 8 10-12h-9l1-8Z',
  award: 'M12 15a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z M8.21 13.89L7 23l5-3 5 3-1.21-9.12',

  // Data & analytics
  barChart: 'M12 20V10 M18 20V4 M6 20v-4',
  trendUp: 'M23 6l-9.5 9.5-5-5L1 18',
  trendDown: 'M23 18l-9.5-9.5-5 5L1 6',
  activity: 'M22 12h-4l-3 9L9 3l-3 9H2',
  pieChart: 'M21.21 15.89A10 10 0 1 1 8 2.83 M22 12A10 10 0 0 0 12 2v10Z',

  // Communication
  message: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z',
  send: 'M22 2L11 13 M22 2l-7 20-4-9-9-4 20-7Z',
  mail: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2Z M22 6l-10 7L2 6',
  // Outline inbox/tray (Feather-style) — the canonical Inbox affordance (Notifications + Messages).
  inbox: 'M22 12 16 12 14 15 10 15 8 12 2 12 M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z',
  gift: 'M20 12v10H4V12 M2 7h20v5H2V7Z M12 22V7 M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7Z M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7Z',

  // Actions
  play: 'M5 3l14 9-14 9V3Z',
  pause: 'M6 4h4v16H6V4Z M14 4h4v16h-4V4Z',
  plus: 'M12 5v14 M5 12h14',
  minus: 'M5 12h14',
  x: 'M18 6L6 18 M6 6l12 12',
  arrowRight: 'M5 12h14 M12 5l7 7-7 7',
  arrowLeft: 'M19 12H5 M12 19l-7-7 7-7',
  externalLink: 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6 M15 3h6v6 M10 14L21 3',
  clipboard: 'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2 M9 2h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Z',
  edit: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7 M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5Z',

  // Objects
  mountain: 'M8 3l4 8 5-5 5 10H2L8 3Z',
  compass: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z M16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36 6.36-2.12Z',
  clock: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z M12 6v6l4 2',
  lightbulb: 'M9 18h6 M10 22h4 M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2Z',
  shield: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z',
  dollar: 'M12 1v22 M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6',
  eye: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  brain: 'M12 2a5 5 0 0 1 3.9 8.1A5.002 5.002 0 0 1 12 22a5 5 0 0 1-3.9-8.1A5 5 0 0 1 12 2Z M12 2v20',
  robot: 'M4 7h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z M9 13h.01 M15 13h.01 M12 2v5 M8 7V5 M16 7V5',

  // Sport-related
  skiPoles: 'M5 22l4-12L5 4 M19 22l-4-12L19 4 M9 10h6',
  snowflake: 'M12 2v20 M4.93 4.93l14.14 14.14 M2 12h20 M4.93 19.07l14.14-14.14',
  diamond: 'M12 2l10 10-10 10L2 12 12 2Z',
  // Skier figure (UXWing, filled) — person skiing with poles
  skier: 'CUSTOM_VB:0 0 110.9 122.88:M39.99,37.79l16.32-11.94L39.36,14.86c-1.59-1.03-2.04-3.15-1.01-4.74c1.03-1.59,3.15-2.04,4.74-1.01l19.14,12.41l3.74-2.74c3.05-1.9,6.34-3.18,8.99-2.83c2.21,0.3,4.25,1.5,6.1,3.84c4.31,5.38,6.96,12.29,9.36,20l9.89,6.41l3.25-0.38c4.48-0.2,6.6,4.45,5.08,7.55c0.02,0.67-0.16,1.36-0.55,1.96c-1.03,1.59-3.15,2.04-4.74,1.01l-0.27-0.18l-9.34,1.03c-5.04,0.57-8.72,1.96-11.46-3.72l-5.81-14.57l-0.76-0.49L58.52,50.38c-1.09,1.14-1.25,2.26-0.16,3.4l13.23,9.62c1.74,1.17,3.21,2,3.57,4.34c0.49,3.15-10.32,22.66-14.43,29.9l23.12,11.7c3.87,1.68,7.09,2.38,9.6,2.03c1.93-0.26,3.53-1.33,4.77-3.24c1.72-2.64,5.25-3.39,7.9-1.68c2.64,1.72,3.4,5.25,1.68,7.9c-3.16,4.87-7.46,7.61-12.82,8.34c-4.61,0.63-9.85-0.37-15.7-2.91c-0.22-0.08-0.43-0.17-0.64-0.28L3.14,81.29c-2.82-1.42-3.95-4.86-2.53-7.67c1.42-2.82,4.86-3.95,7.67-2.53l39.79,20.14l10.63-19.02c-2.99-1.78-5.89-3.56-8.68-5.34C40.71,60.96,28.32,47.41,39.99,37.79z M98.62,0c6.78,0,12.28,5.5,12.28,12.28c0,6.78-5.5,12.28-12.28,12.28s-12.28-5.5-12.28-12.28C86.34,5.5,91.84,0,98.62,0z',
  // Snowboarder figure (Wikimedia, filled) — person on snowboard
  snowboarder: 'CUSTOM_VB:0 0 300 300:M187.727,35.941c10.306-1.429,20.779,5.715,23.398,15.75c2.657,8.732-1.39,18.617-8.835,23.647c-5.605,3.597-12.876,4.701-19.155,2.274c-6.892-2.288-12.168-8.365-13.737-15.422c-1.735-5.236-0.133-10.889,2.342-15.604C174.908,40.668,181.212,36.959,187.727,35.941z M264.717,81.489c4.313-10.387,9.244-20.54,12.246-31.412c1.371,8.266,0.232,16.637,0.406,24.954c0.171,10.066,1.367,21.114-4.111,30.117c-1.883,3.512-5.629,5.623-9.479,6.229c-9.98,1.059-20.041-0.609-29.609-3.439c-6.287-1.846-12.707-4.104-17.768-8.41c-3.357-2.739-5.105-7.604-3.336-11.727c1.396-3.98,5.922-5.845,9.889-5.636c7.599-0.459,14.634,2.716,21.625,5.191c4.52,1.78,8.727,4.246,13.133,6.279C260.043,89.586,262.875,85.806,264.717,81.489z M70.017,74.836c18.66,0.774,37.366,2.854,56.032,1.043c11.381-0.479,22.851-2.718,34.201-0.706c5.798,1.542,8.744,9.961,4.422,14.415c-2.042,2.517-5.183,4.01-8.389,4.27c-8.281,1.2-16.504-0.884-24.722-1.637c-12.179-2.114-24.102-5.458-36.066-8.526C86.571,82.141,78.404,78.066,70.017,74.836z M120.222,109.257c9.127-6.066,18.587-12.888,29.872-13.787c5.714-0.673,11.05,2.667,14.38,7.083c6.079,8.943,10.518,18.924,13.583,29.278c4.677-4.61,9.81-10.232,16.915-10.206c3.869,0.413,8.172,1.911,10.105,5.571c2.084,3.36,1.537,7.482,1.002,11.192c-1.443,7.044-5.213,13.414-10.008,18.698c-9.137,10.065-20.246,18.048-31.493,25.571c-8.929,6.139-18.553,11.172-28.229,16.01c5.995-11.563,13.95-22.073,19.648-33.797c-0.933-4.036-3.648-7.492-4.519-11.598c-3.252-10.151-4.748-20.715-6.448-31.205c-17.621,4.538-34.6,11.28-52.236,15.779c-4.711,1.213-9.361,2.675-14.132,3.646c4.69-4.577,9.306-9.259,14.312-13.494C102.005,121.678,111.213,115.61,120.222,109.257z M36.17,106.134c4.219-1.295,9.018-0.407,12.607,2.141c5.82,4,8.867,10.561,12.956,16.088c12.237,16.824,26.491,32.061,41.324,46.606c18.024,17.476,37.297,33.684,57.806,48.17c7.741,6,16.352,10.833,23.773,17.24c3.912,3.045,5.472,8.836,2.986,13.247c-3.24,5.282-7.869,9.653-13.121,12.912c-4.609,2.722-10.807,3.032-15.374,0.056c-5.991-3.83-9.658-10.139-14.772-14.928c-7.612-7.369-15.454-14.509-22.811-22.137c-20.597-20.127-42.073-39.332-63.032-59.08c-11.12-9.878-24.183-17.702-33.515-29.484c-4.75-5.808-5.146-14.714-1.181-21.027C27.064,111.791,31.099,107.882,36.17,106.134z',
};

/**
 * @param {object} props
 * @param {string} props.name — icon name from PATHS
 * @param {number} [props.size=16] — width/height
 * @param {string} [props.color] — stroke color (defaults to currentColor)
 * @param {number} [props.strokeWidth=2]
 * @param {object} [props.style] — additional inline styles
 */
function MotusIcon({ name, size = 16, color, strokeWidth = 2, style }) {
  const raw = PATHS[name];
  if (!raw) return null;

  // Custom viewBox filled icons (e.g. sport figures from external SVGs)
  if (raw.startsWith('CUSTOM_VB:')) {
    const parts = raw.slice(10);
    const vbEnd = parts.indexOf(':');
    const viewBox = parts.slice(0, vbEnd);
    const d = parts.slice(vbEnd + 1);
    return (
      <svg
        width={size}
        height={size}
        viewBox={viewBox}
        fill={color || 'currentColor'}
        style={{ flexShrink: 0, ...style }}
      >
        <path d={d} />
      </svg>
    );
  }

  // Standard filled icons (24x24 viewBox)
  if (raw.startsWith('FILLED:')) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color || 'currentColor'}
        style={{ flexShrink: 0, ...style }}
      >
        <path d={raw.slice(7)} />
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, ...style }}
    >
      {raw.split(' M').map((seg, i) => (
        <path key={i} d={i === 0 ? seg : `M${seg}`} />
      ))}
    </svg>
  );
}

export { PATHS };
export default MotusIcon;
